// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBVIkDBAFCQSt6udyTjA8wg84wVlIVTTsk',
    authDomain: 'mentometer-f1f08.firebaseapp.com',
    databaseURL: 'https://mentometer-f1f08.firebaseio.com/',
    projectId: 'mentometer-f1f08',
    storageBucket: 'gs://mentometer-f1f08.appspot.com',
    messagingSenderId: '819726352083'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
